var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaultyDevice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.379,
    height: 35.094,
    viewBox: "0 0 33.379 35.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3044"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3040"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1110",
    d: "m191.057 163.359-2.7 2.851a3.094 3.094 0 0 1 1.085 2.355v7.528a3.1 3.1 0 0 1-3.1 3.1h-7.528a3.088 3.088 0 0 1-2.028-.757l-2.668 2.818a3.416 3.416 0 0 0 2.176.781h12.6a3.426 3.426 0 0 0 3.425-3.425v-12.6a3.412 3.412 0 0 0-1.262-2.651z",
    transform: "translate(-165.415 -154.448)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1111",
    d: "m252.163 236.868-9.035 9.546a1.248 1.248 0 0 0 .76.255h7.528a1.261 1.261 0 0 0 1.26-1.26v-7.528a1.253 1.253 0 0 0-.513-1.013zm-2.1 8.7a1.2 1.2 0 0 1 0-2.391 1.2 1.2 0 0 1-.004 2.393z",
    transform: "translate(-230.489 -223.765)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3038"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2031",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.842v3.78H0z",
    transform: "translate(10.911 29.559)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2032",
    transform: "translate(14.336 29.559)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.842v3.78H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2033",
    transform: "translate(17.76 29.559)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.842v3.78H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2034",
    transform: "translate(21.152 29.559)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.842v3.78H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3039"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2035",
    transform: "translate(28.874 22.29)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.78v1.842H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2036",
    transform: "translate(28.874 18.866)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.78v1.842H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2037",
    transform: "translate(28.874 15.441)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.78v1.841H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2038",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.78v1.842H0z",
    transform: "translate(28.874 12.049)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2039",
    transform: "rotate(-46.6 39.885 17.034)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h47.222v1.141H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3043"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1112",
    d: "M132.983 132.954v-7.311a3.013 3.013 0 0 1 3.017-3.012h7.311a3 3 0 0 1 1.959.725l2.621-2.769a3.318 3.318 0 0 0-2.1-.749h-12.243a3.328 3.328 0 0 0-3.326 3.326V135.4a3.313 3.313 0 0 0 1.213 2.567l2.591-2.737a3 3 0 0 1-1.043-2.276z",
    transform: "translate(-124.197 -112.594)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1113",
    d: "M220.894 202.542h-7.311a1.225 1.225 0 0 0-1.224 1.224v7.311a1.229 1.229 0 0 0 .486.976l8.775-9.271a1.223 1.223 0 0 0-.726-.24zm-5.836 3.671a1.161 1.161 0 0 1 0-2.322 1.161 1.161 0 0 1 0 2.322z",
    transform: "translate(-201.784 -190.717)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3041"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2040",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.789v3.671H0z",
    transform: "translate(9.382 2.066)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2041",
    transform: "translate(12.708 2.066)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.789v3.671H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2042",
    transform: "translate(16.034 2.066)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.789v3.671H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2043",
    transform: "translate(19.329 2.066)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h1.789v3.671H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3042"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2044",
    transform: "translate(0 20.987)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.671v1.789H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2045",
    transform: "translate(0 17.661)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.671v1.789H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2046",
    transform: "translate(0 14.335)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.671v1.789H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2047",
    style: {
      fill: "#fff"
    },
    d: "M0 0h3.671v1.789H0z",
    transform: "translate(0 11.04)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaultyDevice);
export default __webpack_public_path__ + "static/media/Faulty_Device.284ebfad9cded8fb53c874164fb08f99.svg";
export { ForwardRef as ReactComponent };